import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "@phosphor-icons/react";
import { fmtDate } from "@/lib/fmt";

const pad = (n) => String(n).padStart(2, "0");

// Cockpit HUD strip: live clock, link status, system pulse (admins), role badge.
export const HudBar = ({ label }) => {
  const { user } = useAuth();
  const [now, setNow] = useState(new Date());
  const [health, setHealth] = useState(null);
  const admin = ["owner", "administrator"].includes(user?.role);
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(id); }, []);
  useEffect(() => {
    if (!admin) return undefined;
    let alive = true;
    const pull = () => api.get("/admin/system-health").then((r) => alive && setHealth(r.data)).catch(() => {});
    pull(); const id = setInterval(pull, 60000);
    return () => { alive = false; clearInterval(id); };
  }, [admin]);
  const checks = Object.values(health?.checks || {});
  const bad = checks.filter((c) => c.status !== "green").length;
  const dot = !health ? "" : bad === 0 ? "" : checks.some((c) => c.status === "red") ? "is-bad" : "is-warn";
  const sysText = !admin ? "Link secure" : !health ? "Systems…" : bad === 0 ? `All ${checks.length} systems go` : `${bad} degraded`;
  return (
    <div className="mfg-hud-bar hidden lg:flex" data-testid="hud-bar">
      <span className="mfg-hud-seg"><span className="mfg-hud-radar" /> <span className="text-[#F8FAFC]" data-testid="hud-page">{label}</span></span>
      <span className="mfg-hud-seg"><span className={`mfg-hud-dot ${dot}`} /> <span data-testid="hud-systems">{sysText}</span></span>
      <span className="mfg-hud-seg"><ShieldCheck size={13} weight="fill" className="text-[#0A84FF]" /> Encrypted session</span>
      <span className="ml-auto mfg-hud-seg"><span className="mfg-hud-role" data-testid="hud-role">{(user?.role || "").replace(/_/g, " ")}</span></span>
      <span className="mfg-hud-seg">
        <span data-testid="hud-date">{fmtDate(now)}</span>
        <span className="mfg-hud-clock" data-testid="hud-clock">{pad(now.getHours())}:{pad(now.getMinutes())}<span className="opacity-60">:{pad(now.getSeconds())}</span></span>
        <span className="opacity-60">{pad(now.getUTCHours())}:{pad(now.getUTCMinutes())}Z</span>
      </span>
    </div>
  );
};

export default HudBar;
